import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import CardNetworksMetadataProperties from './_common/_props/CardNetworksMetadataProperties.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Called when new validation metadata relating to the current validation state is received. This will always be
called some time after `}<inlineCode parentName="p">{`primerRawDataManager(_:willFetchMetadataForState:)`}</inlineCode>{` is called.`}</p>
    <p>{`Use this method to query new validation metadata, add informational UI, or allow the user to add
additional payment information required to make a payment.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func primerRawDataManager(_ rawDataManager: PrimerHeadlessUniversalCheckout.RawDataManager,
                          didReceiveMetadata metadata: PrimerPaymentMethodMetadata,
                          forState state: PrimerValidationState)
`}</code></pre>
    <h4>{`Parameters`}</h4>
    <Group mdxType="Group">
	<Item title='rawDataManager' subtitle='PrimerHeadlessUniversalCheckout.RawDataManager' mdxType="Item">
		The instance of the raw data manager calling this delegate method.
	</Item>
      <Item title='metadata' subtitle='PrimerPaymentMethodMetadata' mdxType="Item">
        <p>{`An object containing metadata for the relevant `}<inlineCode parentName="p">{`state`}</inlineCode>{` also returned with this method.`}</p>
        <Group summary='Implementations' open mdxType="Group">
          <Item title='class PrimerCardNumberEntryState' mdxType="Item">
            <p>{`Used when `}<inlineCode parentName="p">{`rawData`}</inlineCode>{` is set to `}<inlineCode parentName="p">{`PrimerCardData`}</inlineCode></p>
            <Group summary='Properties' open mdxType="Group">
              <Item title="cardNumber" subtitle="String" label="Required" mdxType="Item">
                <p>{`The card number set on `}<inlineCode parentName="p">{`rawData`}</inlineCode>{` that triggered the metadata fetch`}</p>
              </Item>
            </Group>
          </Item>
        </Group>
      </Item>
      <Item title='state' subtitle='PrimerValidationState' mdxType="Item">
        <p>{`An object containing the state that triggered the metadata fetch. For example, for
card number entry, this will be an instance of `}<inlineCode parentName="p">{`PrimerCardNumberEntryState`}</inlineCode></p>
        <Group summary='Implementations' open mdxType="Group">
          <Item title='class PrimerCardNumberEntryMetadata' mdxType="Item">
Card network metadata including selectable card networks and detected card networks.
            <Group summary='Properties' open mdxType="Group">
              <Item title="source" subtitle="PrimerCardValidationSource" label="Required" mdxType="Item">
Enum value indicating the source of the validation.
                <Group summary='cases' open mdxType="Group">
                  <Item title='.remote' mdxType="Item">
Indicates that remote validation occurred using Primer APIs.
                  </Item>
                  <Item title='.localFallback' mdxType="Item">
Indicates that remote validation was attempted but could not be completed, causing a fallback to local validation.
                  </Item>
                  <Item title='.local' mdxType="Item">
Indicates that the validation occurred locally, usually leveraging the first few digits of the card number.
                  </Item>
                </Group>
              </Item>
              <Item title='selectableCardNetworks' subtitle='PrimerCardNetworksMetadata?' mdxType="Item">
Card networks for the given card number that can be selected by the user prior to payment. This will be null in the case that a network is co-badged, or we are unable to remotely validate the given card number.
                <CardNetworksMetadataProperties mdxType="CardNetworksMetadataProperties" />
              </Item>
              <Item title="detectedCardNetworks" subtitle="PrimerCardNetworksMetadata" label="Required" mdxType="Item">
All detected card networks for the given card number. This will include networks even if they are not merchant-supported.
                <CardNetworksMetadataProperties mdxType="CardNetworksMetadataProperties" />
              </Item>
            </Group>
          </Item>
        </Group>
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      